import { createContext } from "solid-js"
import type { AppStore } from "./types"

/**
 * Context for AppStore
 * Provides reactive access to app/UI state throughout the component tree
 */
export const AppContext = createContext<AppStore>()
